import FloatingCompoundTable from "@/components/FloatingCompoundTable.vue";
import { getDescriptionBasedOnKpiKey, getColorsBasedOnRange, getColorForDecile } from "@/utils/transformers";
import { EVENTS, COLORS, ECPM_DECILE_COLORS, DSP_DELIVERY_RATE_BG_COLORS, DSP_DELIVERY_RATE_COLORS, DSP_NTB_CUSTOMERS_RATE_COLORS, DSP_NTB_CUSTOMERS_RATE_BG_COLORS } from "@/utils/constants";
import { truncateString } from "@/utils";
import { country_code_amz_sp_api_marketplace_ids, amz_sp_api_marketplace_ids_country_domains, country_code_amz_sp_api_marketplace_ids_flipped, amz_sp_api_marketplace_ids_country_domains_flipped } from "@/utils/countries";
import WrapWithPopover from "@/components/shared/WrapWithPopover.vue";
import WrapWithArrow from "@/components/tableElements/WrapWithArrow.vue";
import ProductTableGroupBy from "@/components/dsp_report/ProductTableGroupBy.vue";
import { mapState, mapGetters } from "vuex";
import { SELLER_FIELD, MARKETPLACE_FIELD, DSP_NEW_CUSTOMERS_FIELD, DSP_ROAS_VS_TARGET_FIELD, DSP_CPA_CONVERSION_FIELD, DSP_SPEND_FIELD, DSP_ASSISTED_SALES_FIELD, DSP_PERCENT_ASSISTED_SALES_FIELD, DSP_UNITS_SOLD_FIELD, DSP_ATC_CLICKS_FIELD, DSP_ATC_VIEWS_FIELD, DSP_DPV_CLICKS_FIELD, DSP_DPV_VIEWS_FIELD, DSP_BRAND_SEARCHES_FIELD, DSP_ECPM_FIELD, DSP_IMPRESSIONS_FIELD, DSP_VTR_FIELD, DSP_DELIVERY_RATE_FIELD, DSP_PERCENT_NTB_CUST_FIELD, DSP_CVR_FIELD, DSP_POST_CLICK_PURCH_FIELD, DSP_HALO_FIELD, DSP_CAMPAIGN_FIELD, DSP_LINE_ITEM_FIELD, DSP_CONSIDERATION_SIGNALS_FIELD, DSP_DPVR_VS_TARGET_FIELD, DSP_CPA_CONSIDERATION_FIELD, DSP_DPV_FIELD, DSP_ATC_FIELD, DSP_PERCENT_DPV_CLICK_FIELD, DSP_REPURCHASES_FIELD, DSP_CPA_LOYALTY_FIELD, DSP_PERCENT_EXISTING_CUST_FIELD } from "@/utils/table_fields";
import FlexRow from "@/components/FlexRow.vue";
import { HugValue, DateValue, CurrencyValue, NumberValue, PercentageValue, BoxedValue, BarWithValue, OverlapBarValue, ValueElement, MarketplaceValue, DotElement } from "@/components/tableElements";
import ProductTableTotal from "@/components/dsp_report/ProductTableTotal.vue";
import LiteTableMixin from "@/mixins/LiteTableMixin.vue";
import SlotWithEvolutionValue from "@/components/tableElements/SlotWithEvolutionValue.vue";
import EvolutionValue from "@/components/tableElements/EvolutionValue.vue";
export default {
  name: "ProductTable",
  components: {
    HugValue,
    DateValue,
    CurrencyValue,
    NumberValue,
    PercentageValue,
    SlotWithEvolutionValue,
    EvolutionValue,
    WrapWithPopover,
    FlexRow,
    BoxedValue,
    BarWithValue,
    OverlapBarValue,
    ProductTableGroupBy,
    ProductTableTotal,
    FloatingCompoundTable,
    ValueElement,
    MarketplaceValue,
    DotElement,
    WrapWithArrow
  },
  emits: ["refresh", "changeDate", "refreshOtherKpis", "restoreEvolutionTable"],
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },
  mixins: [LiteTableMixin],
  data() {
    return {
      EVENTS,
      COLORS,
      ECPM_DECILE_COLORS,
      DSP_DELIVERY_RATE_BG_COLORS,
      DSP_DELIVERY_RATE_COLORS,
      DSP_NTB_CUSTOMERS_RATE_COLORS,
      DSP_NTB_CUSTOMERS_RATE_BG_COLORS,
      country_code_amz_sp_api_marketplace_ids,
      amz_sp_api_marketplace_ids_country_domains,
      country_code_amz_sp_api_marketplace_ids_flipped,
      amz_sp_api_marketplace_ids_country_domains_flipped,
      evolCategory: {
        prev_period: "_vs_previous_period",
        same_period_ly: "_vs_previous_year"
      },
      fieldsSources: {
        conversion: {
          seller: [SELLER_FIELD, DSP_NEW_CUSTOMERS_FIELD, DSP_ROAS_VS_TARGET_FIELD, DSP_CPA_CONVERSION_FIELD, DSP_SPEND_FIELD, DSP_ASSISTED_SALES_FIELD, DSP_PERCENT_ASSISTED_SALES_FIELD, DSP_UNITS_SOLD_FIELD, DSP_ATC_CLICKS_FIELD, DSP_ATC_VIEWS_FIELD, DSP_DPV_CLICKS_FIELD, DSP_DPV_VIEWS_FIELD, DSP_BRAND_SEARCHES_FIELD, DSP_ECPM_FIELD, DSP_IMPRESSIONS_FIELD, DSP_VTR_FIELD, DSP_DELIVERY_RATE_FIELD, DSP_PERCENT_NTB_CUST_FIELD, DSP_CVR_FIELD, DSP_POST_CLICK_PURCH_FIELD, DSP_HALO_FIELD],
          marketplace: [MARKETPLACE_FIELD, DSP_NEW_CUSTOMERS_FIELD, DSP_ROAS_VS_TARGET_FIELD, DSP_CPA_CONVERSION_FIELD, DSP_SPEND_FIELD, DSP_ASSISTED_SALES_FIELD, DSP_PERCENT_ASSISTED_SALES_FIELD, DSP_UNITS_SOLD_FIELD, DSP_ATC_CLICKS_FIELD, DSP_ATC_VIEWS_FIELD, DSP_DPV_CLICKS_FIELD, DSP_DPV_VIEWS_FIELD, DSP_BRAND_SEARCHES_FIELD, DSP_ECPM_FIELD, DSP_IMPRESSIONS_FIELD, DSP_VTR_FIELD, DSP_DELIVERY_RATE_FIELD, DSP_PERCENT_NTB_CUST_FIELD, DSP_CVR_FIELD, DSP_POST_CLICK_PURCH_FIELD, DSP_HALO_FIELD],
          campaign: [DSP_CAMPAIGN_FIELD, DSP_NEW_CUSTOMERS_FIELD, DSP_ROAS_VS_TARGET_FIELD, DSP_CPA_CONVERSION_FIELD, DSP_SPEND_FIELD, DSP_ASSISTED_SALES_FIELD, DSP_PERCENT_ASSISTED_SALES_FIELD, DSP_UNITS_SOLD_FIELD, DSP_ATC_CLICKS_FIELD, DSP_ATC_VIEWS_FIELD, DSP_DPV_CLICKS_FIELD, DSP_DPV_VIEWS_FIELD, DSP_BRAND_SEARCHES_FIELD, DSP_ECPM_FIELD, DSP_IMPRESSIONS_FIELD, DSP_VTR_FIELD, DSP_DELIVERY_RATE_FIELD, DSP_PERCENT_NTB_CUST_FIELD, DSP_CVR_FIELD, DSP_POST_CLICK_PURCH_FIELD, DSP_HALO_FIELD],
          line_item: [DSP_LINE_ITEM_FIELD, DSP_NEW_CUSTOMERS_FIELD, DSP_ROAS_VS_TARGET_FIELD, DSP_CPA_CONVERSION_FIELD, DSP_SPEND_FIELD, DSP_ASSISTED_SALES_FIELD, DSP_PERCENT_ASSISTED_SALES_FIELD, DSP_UNITS_SOLD_FIELD, DSP_ATC_CLICKS_FIELD, DSP_ATC_VIEWS_FIELD, DSP_DPV_CLICKS_FIELD, DSP_DPV_VIEWS_FIELD, DSP_BRAND_SEARCHES_FIELD, DSP_ECPM_FIELD, DSP_IMPRESSIONS_FIELD, DSP_VTR_FIELD, {
            ...DSP_PERCENT_NTB_CUST_FIELD,
            class: ["left-embrace", "control"]
          }, DSP_CVR_FIELD, DSP_POST_CLICK_PURCH_FIELD, DSP_HALO_FIELD]
        },
        consideration: {
          seller: [SELLER_FIELD, DSP_CONSIDERATION_SIGNALS_FIELD, DSP_DPVR_VS_TARGET_FIELD, DSP_CPA_CONSIDERATION_FIELD, DSP_SPEND_FIELD, DSP_DPV_FIELD, DSP_ATC_FIELD, {
            ...DSP_BRAND_SEARCHES_FIELD,
            class: ["right-embrace", "left-embrace", "brand_interest"]
          }, DSP_ECPM_FIELD, DSP_IMPRESSIONS_FIELD, DSP_VTR_FIELD, DSP_DELIVERY_RATE_FIELD, DSP_PERCENT_NTB_CUST_FIELD, DSP_PERCENT_DPV_CLICK_FIELD],
          marketplace: [MARKETPLACE_FIELD, DSP_CONSIDERATION_SIGNALS_FIELD, DSP_DPVR_VS_TARGET_FIELD, DSP_CPA_CONSIDERATION_FIELD, DSP_SPEND_FIELD, DSP_DPV_FIELD, DSP_ATC_FIELD, {
            ...DSP_BRAND_SEARCHES_FIELD,
            class: ["right-embrace", "left-embrace", "brand_interest"]
          }, DSP_ECPM_FIELD, DSP_IMPRESSIONS_FIELD, DSP_VTR_FIELD, DSP_DELIVERY_RATE_FIELD, DSP_PERCENT_NTB_CUST_FIELD, DSP_PERCENT_DPV_CLICK_FIELD],
          campaign: [DSP_CAMPAIGN_FIELD, DSP_CONSIDERATION_SIGNALS_FIELD, DSP_DPVR_VS_TARGET_FIELD, DSP_CPA_CONSIDERATION_FIELD, DSP_SPEND_FIELD, DSP_DPV_FIELD, DSP_ATC_FIELD, {
            ...DSP_BRAND_SEARCHES_FIELD,
            class: ["right-embrace", "left-embrace", "brand_interest"]
          }, DSP_ECPM_FIELD, DSP_IMPRESSIONS_FIELD, DSP_VTR_FIELD, DSP_DELIVERY_RATE_FIELD, DSP_PERCENT_NTB_CUST_FIELD, DSP_PERCENT_DPV_CLICK_FIELD],
          line_item: [DSP_LINE_ITEM_FIELD, DSP_CONSIDERATION_SIGNALS_FIELD, DSP_DPVR_VS_TARGET_FIELD, DSP_CPA_CONSIDERATION_FIELD, DSP_SPEND_FIELD, DSP_DPV_FIELD, DSP_ATC_FIELD, {
            ...DSP_BRAND_SEARCHES_FIELD,
            class: ["right-embrace", "left-embrace", "brand_interest"]
          }, DSP_ECPM_FIELD, DSP_IMPRESSIONS_FIELD, DSP_VTR_FIELD, {
            ...DSP_PERCENT_NTB_CUST_FIELD,
            class: ["left-embrace", "control"]
          }, DSP_PERCENT_DPV_CLICK_FIELD]
        },
        loyalty: {
          seller: [SELLER_FIELD, DSP_REPURCHASES_FIELD, DSP_ROAS_VS_TARGET_FIELD, DSP_CPA_LOYALTY_FIELD, DSP_SPEND_FIELD, DSP_ASSISTED_SALES_FIELD, DSP_PERCENT_ASSISTED_SALES_FIELD, DSP_UNITS_SOLD_FIELD, DSP_ATC_CLICKS_FIELD, DSP_ATC_VIEWS_FIELD, DSP_DPV_CLICKS_FIELD, DSP_DPV_VIEWS_FIELD, DSP_BRAND_SEARCHES_FIELD, DSP_ECPM_FIELD, DSP_IMPRESSIONS_FIELD, DSP_VTR_FIELD, DSP_DELIVERY_RATE_FIELD, DSP_PERCENT_EXISTING_CUST_FIELD, DSP_CVR_FIELD, DSP_POST_CLICK_PURCH_FIELD, DSP_HALO_FIELD],
          marketplace: [MARKETPLACE_FIELD, DSP_REPURCHASES_FIELD, DSP_ROAS_VS_TARGET_FIELD, DSP_CPA_LOYALTY_FIELD, DSP_SPEND_FIELD, DSP_ASSISTED_SALES_FIELD, DSP_PERCENT_ASSISTED_SALES_FIELD, DSP_UNITS_SOLD_FIELD, DSP_ATC_CLICKS_FIELD, DSP_ATC_VIEWS_FIELD, DSP_DPV_CLICKS_FIELD, DSP_DPV_VIEWS_FIELD, DSP_BRAND_SEARCHES_FIELD, DSP_ECPM_FIELD, DSP_IMPRESSIONS_FIELD, DSP_VTR_FIELD, DSP_DELIVERY_RATE_FIELD, DSP_PERCENT_EXISTING_CUST_FIELD, DSP_CVR_FIELD, DSP_POST_CLICK_PURCH_FIELD, DSP_HALO_FIELD],
          campaign: [DSP_CAMPAIGN_FIELD, DSP_REPURCHASES_FIELD, DSP_ROAS_VS_TARGET_FIELD, DSP_CPA_LOYALTY_FIELD, DSP_SPEND_FIELD, DSP_ASSISTED_SALES_FIELD, DSP_PERCENT_ASSISTED_SALES_FIELD, DSP_UNITS_SOLD_FIELD, DSP_ATC_CLICKS_FIELD, DSP_ATC_VIEWS_FIELD, DSP_DPV_CLICKS_FIELD, DSP_DPV_VIEWS_FIELD, DSP_BRAND_SEARCHES_FIELD, DSP_ECPM_FIELD, DSP_IMPRESSIONS_FIELD, DSP_VTR_FIELD, DSP_DELIVERY_RATE_FIELD, DSP_PERCENT_EXISTING_CUST_FIELD, DSP_CVR_FIELD, DSP_POST_CLICK_PURCH_FIELD, DSP_HALO_FIELD],
          line_item: [DSP_LINE_ITEM_FIELD, DSP_REPURCHASES_FIELD, DSP_ROAS_VS_TARGET_FIELD, DSP_CPA_LOYALTY_FIELD, DSP_SPEND_FIELD, DSP_ASSISTED_SALES_FIELD, DSP_PERCENT_ASSISTED_SALES_FIELD, DSP_UNITS_SOLD_FIELD, DSP_ATC_CLICKS_FIELD, DSP_ATC_VIEWS_FIELD, DSP_DPV_CLICKS_FIELD, DSP_DPV_VIEWS_FIELD, DSP_BRAND_SEARCHES_FIELD, DSP_ECPM_FIELD, DSP_IMPRESSIONS_FIELD, DSP_VTR_FIELD, {
            ...DSP_PERCENT_EXISTING_CUST_FIELD,
            class: ["left-embrace", "control"]
          }, DSP_CVR_FIELD, DSP_POST_CLICK_PURCH_FIELD, DSP_HALO_FIELD]
        }
      },
      CLICK_TO_FILTER_OPTIONS: {
        seller: this.sellersClickToFilter,
        marketplace: this.marketplacesClickToFilter,
        line_item: this.lineItemClickToFilter,
        campaign: this.campaignClickToFilter
      },
      CLICK_TO_CLEAR_FILTER_OPTIONS: {
        seller: this.sellersClickToClearFilter,
        marketplace: this.marketplacesClickToClearFilter,
        line_item: this.lineItemClickToClearFilter,
        campaign: this.campaignClickToClearFilter
      }
    };
  },
  computed: {
    ...mapState({
      groupBy: state => state.dsp_report.product_table.group_by_text,
      productTable: state => state.dsp_report.product_table,
      currentTabValue: state => state.dsp_report.currentTabValue,
      periodCategory: state => state.dsp_report.periodCategory,
      currencyConfig: state => state.dsp_report.currencyConfig,
      sellers_filter: state => state.dsp_report.sellers_filter,
      marketplaces_filter: state => state.dsp_report.marketplaces_filter,
      campaigns: state => state.dsp_report.campaigns,
      line_items: state => state.dsp_report.line_items,
      period: state => state.dsp_report.period,
      accounts: state => state.account.list
    }),
    ...mapGetters(["dspSingleMarketplace", "getCountryFlag"]),
    filteredItems() {
      const goalMap = {
        conversion: 'CONVERSIONS',
        consideration: 'CONSIDERATION',
        loyalty: 'LOYALTY',
        awareness: 'AWARENESS'
      };
      const rows = this.productTable[this.currentTabValue].data[this.groupBy]?.items;
      if (['line_item', 'campaign'].includes(this.groupBy)) {
        return rows?.filter(item => item.goal === goalMap[this.currentTabValue]);
      }
      return rows;
    },
    total() {
      return this.productTable[this.currentTabValue].data[this.groupBy]?.total;
    },
    minMax() {
      //console.log('minMax', this.productTable[this.currentTabValue].data[this.groupBy]?.minMax);
      return this.productTable[this.currentTabValue].data[this.groupBy]?.minMax;
    },
    sort() {
      return this.productTable[this.currentTabValue].data[this.groupBy]?.sort;
    },
    maxCharCount() {
      return this.productTable[this.currentTabValue].data[this.groupBy]?.maxCharCount;
    },
    fields() {
      return this.fieldsSources[this.currentTabValue][this.groupBy];
    },
    datePickerDate() {
      return this.productTable[this.currentTabValue].period;
    },
    fieldKeyMap() {
      return {
        seller_name: 'seller_name',
        sales_channel: 'sales_channel',
        order_id: 'order_name',
        line_item_id: 'line_item_name',
        dsp_new_customers: 'conversion_new_customers',
        dsp_roas_vs_target: `${this.currentTabValue}_roas`,
        dsp_cpa_conversion: 'conversion_cpa_ntb',
        dsp_spend: `${this.currentTabValue}_spend`,
        dsp_assisted_sales: `${this.currentTabValue}_assisted_sales`,
        dsp_percent_assisted_sales: `${this.currentTabValue}_pct_main_assisted_sales`,
        dsp_units_sold: `${this.currentTabValue}_units_sold`,
        dsp_atc_clicks: `${this.currentTabValue}_atc_clicks`,
        dsp_atc_views: `${this.currentTabValue}_atc_views`,
        dsp_dpv_clicks: `${this.currentTabValue}_dpv_clicks`,
        dsp_dpv_views: `${this.currentTabValue}_dpv_views`,
        dsp_brand_searches: `${this.currentTabValue}_brand_searches`,
        dsp_ecpm: `${this.currentTabValue}_ecpm`,
        dsp_impressions: `${this.currentTabValue}_viewable_impressions`,
        dsp_vtr: `${this.currentTabValue}_vtr`,
        dsp_delivery_rate: `${this.currentTabValue}_delivery_rate`,
        dsp_percent_ntb_cust: `${this.currentTabValue}_share_of_ntb`,
        dsp_cvr: `${this.currentTabValue}_cvr_dpv_click_to_purchase`,
        dsp_post_click_purch: `${this.currentTabValue}_post_click_purchase_ratio`,
        dsp_halo: `${this.currentTabValue}_halo_effect`,
        dsp_consideration_signals: 'consideration_signals',
        dsp_dpvr_vs_target: 'consideration_dpvr',
        dsp_cpa_consideration: 'consideration_cpa_signal',
        dsp_dpv: 'consideration_dpv',
        dsp_atc: 'consideration_atc',
        dsp_percent_dpv_click: 'consideration_dpv_click_ratio',
        dsp_repurchases: 'loyalty_repurchases',
        dsp_cpa_loyalty: 'loyalty_cpa_repurchase',
        dsp_percent_existing_cust: 'loyalty_share_of_existing_customers'
      };
    },
    page: {
      set(val) {
        this.$store.dispatch("dspSetProductTablePage", val);
        this.$emit("refresh");
      },
      get() {
        return this.$store.getters.dspGetProductTablePage();
      }
    },
    perPage: {
      set(val) {
        this.$store.dispatch("dspSetProductTablePerPage", val);
        this.$emit("refresh");
      },
      get() {
        return this.$store.getters.dspGetProductTablePerPage();
      }
    },
    totalPages: {
      set(val) {
        this.$store.dispatch("dspSetProductTableTotalPages", val);
      },
      get() {
        return this.$store.getters.dspGetProductTableTotalPages();
      }
    },
    getTbodyTrClass() {
      return item => this.handleRowClass(item, this.filteredItems);
    },
    getThClass() {
      return field => {
        return [];
      };
    }
  },
  methods: {
    getDescriptionBasedOnKpiKey,
    getColorsBasedOnRange,
    getColorForDecile,
    truncateString,
    handleDatePickerSubmit(date) {
      this.$emit("changeDate", date);
      this.$emit("restoreEvolutionTable");
      window.$bus.trigger(EVENTS.FLOATING_COMPOUND_TABLE_OPEN_COLLAPSE);
    },
    handleTableState(state) {
      this.$store.dispatch("dspSetProductTableState", state);
    },
    handleGroupByRefresh() {
      this.$emit('refresh');
    },
    handleClicked() {
      window.$bus.trigger(EVENTS.FLOATING_COMPOUND_TABLE_OPEN_COLLAPSE);
    },
    handleHeadClick(key) {
      const fieldKey = this.fieldKeyMap[key];
      const directionFlip = {
        asc: "desc",
        desc: "asc"
      };
      if (this.loading) return;
      const direction = directionFlip[this.sort[fieldKey]] ?? "desc";
      this.handleSort({
        sort: fieldKey,
        direction
      });
    },
    async sellersClickToFilter(item) {
      // Set the `seller` filter
      this.sellers_filter.selectOnly({
        id: item.seller_id
      }, 'id');
      this.sellers_filter.apply();
      await window.$bus.trigger(EVENTS.REFRESH_DSP_SELLERS_SUB_FILTERS);
      this.$emit('refreshOtherKpis');
    },
    async sellersClickToClearFilter() {
      // Set the `seller` filter
      this.sellers_filter.clear();
      this.sellers_filter.apply();
      await window.$bus.trigger(EVENTS.REFRESH_DSP_SELLERS_SUB_FILTERS);
      await this.$emit('refreshOtherKpis');
    },
    async marketplacesClickToFilter(item) {
      this.marketplaces_filter.selectOnly({
        sales_channel: item?.sales_channel
      }, 'sales_channel');

      // Set the current group by to `product`
      this.marketplaces_filter.apply();
      await window.$bus.trigger(EVENTS.REFRESH_DSP_MARKETPLACES_SUB_FILTERS);
      await this.$emit('refreshOtherKpis');
    },
    async marketplacesClickToClearFilter() {
      // Set the `marketplace` filter
      this.marketplaces_filter.clear();
      this.marketplaces_filter.apply();
      await window.$bus.trigger(EVENTS.REFRESH_DSP_MARKETPLACES_SUB_FILTERS);
      await this.$emit('refreshOtherKpis');
    },
    async campaignClickToFilter(item) {
      this.campaigns.selectOnly({
        order_id: item?.order_id
      }, 'order_id');
      this.campaigns.apply();
      await window.$bus.trigger(EVENTS.REFRESH_DSP_CAMPAIGNS_SUB_FILTERS);
      await this.$emit('refreshOtherKpis');
    },
    async campaignClickToClearFilter() {
      await this.campaigns.clear();
      this.campaigns.apply();
      await window.$bus.trigger(EVENTS.REFRESH_DSP_CAMPAIGNS_SUB_FILTERS);
      await this.$emit('refreshOtherKpis');
    },
    async lineItemClickToFilter(item) {
      this.line_items.selectOnly({
        line_item_id: item?.line_item_id
      }, 'line_item_id');
      this.line_items.apply();
      await this.$emit('refreshOtherKpis');
    },
    async lineItemClickToClearFilter() {
      await this.line_items.clear();
      this.line_items.apply();
      await this.$emit('refreshOtherKpis');
    },
    async handleBreakdownReset() {
      const clickToClearFilter = this.CLICK_TO_CLEAR_FILTER_OPTIONS[this.groupBy];
      await clickToClearFilter();
    },
    async handleBreakdownSelect(item) {
      const clickToFilter = this.CLICK_TO_FILTER_OPTIONS[this.groupBy];
      await clickToFilter(item);
    },
    async handleRowClick(item, _, event) {
      //console.log('handleRowClick', event)
      const performanceFloatingCompoundTable = this.$refs.performanceFloatingCompoundTable;
      if (performanceFloatingCompoundTable) {
        performanceFloatingCompoundTable.handleNormalize();
      }
      this.handleBreakdownRowClicked(item, this.handleBreakdownReset, this.handleBreakdownSelect, this.filteredItems);
    },
    getSellerNameFromId(seller_id) {
      return this.accounts?.filter(item => item.account_id === seller_id)[0]?.account_name;
    }
  }
};